import axios from 'axios'

export default {
  async getVehicleInfo(licensePlate) {
    try {
      if (!licensePlate) {
        console.warn('The LicensePlate was null or undefined.')
        return null
      }

      const trimmedLicensePlate = licensePlate.replace(/-/g, '')
      const response = await axios.get(
        `SearchVehicleInformationByLicensePlate/${trimmedLicensePlate}`
      )
      return response.data
    } catch (e) {
      if (e.response.status == 404) {
        return null
      } else {
        return Promise.reject(e)
      }
    }
  },
}
